import { render, staticRenderFns } from "./RidesSearch.vue?vue&type=template&id=53c96ce8&scoped=true"
import script from "./RidesSearch.vue?vue&type=script&lang=js"
export * from "./RidesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c96ce8",
  null
  
)

export default component.exports